import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import Sprite from '../../../Sprite';
import Point from '../../../../Utility/Point';

export default class LoweringModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);
        const loweringSprite = GameObject.Instantiate(Sprite, {
            name: 'loweringSprite',
            texture: 'cards_lowering',
            anchor: new Point(0.5, 0.5),
        });

        this.addChild(loweringSprite);
    }
}
